import initializeSvelteApp from "common/initializeSvelteApp";
import App from "./App";

initializeSvelteApp({
  component: App,
  target: ".js-ticketbuyer-payment-day",
  props: (element) => {
    return {
      url: element.getAttribute("data-payment-day-url"),
      strings: JSON.parse(element.getAttribute("data-strings")),
      is_present: JSON.parse(element.getAttribute("data-is-present")),
      is_future: element.getAttribute("data-is-future"),
      next_process_at: element.getAttribute("data-next-process-at"),
      payment_day: +element.getAttribute("data-payment-day"),
    };
  },
});
